import { SMSVGProps } from './SMSVGProps'
import React from 'react'

export default function Wave(props: SMSVGProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288.88 127.79">
      <defs>
        <style>{`
      .cls-wave-1{fill:${props.color || '#CCC'};}`}</style>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="FOND">
          <path
            className="cls-wave-1"
            d="M288.88,127.79H0V8.12A320.48,320.48,0,0,1,67.15,0c54.07-.75,79,12.8,131.89,15.37a356,356,0,0,0,89.84-7.28Z"
          />
        </g>
      </g>
    </svg>
  )
}
